import { Box, Button, Slider, Typography, styled } from '@mui/material';

export const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[400],
  '&:hover, &:active, &:focus': {
    background: 'transparent',
  },
  '& .MuiSvgIcon-root': {
    fontSize: 24,
  },
}));

export const SliderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: theme.spacing(16.25),
  height: theme.spacing(10),
  backgroundColor: theme.palette.grey[700],
  borderRadius: theme.spacing(0.5),
}));

export const CustomSlider = styled(Slider)(({ theme }) => ({
  width: '80%',
  '& .MuiSlider-rail': {
    height: theme.spacing(0.375),
    color: theme.palette.grey[400],
  },
  '& .MuiSlider-track': {
    height: theme.spacing(0.375),
  },
  '& .MuiSlider-thumb': {
    height: theme.spacing(1.625),
    width: theme.spacing(1.625),
    backgroundColor: theme.palette.common.white,
  },
}));

export const TimeInterval = styled(Typography)({
  textAlign: 'center',
  fontSize: '0.75rem',
  fontWeight: 'normal',
  lineHeight: 1.33,
  letterSpacing: 'normal',
});
